import { createSlice } from '@reduxjs/toolkit';

const actionsSlice = createSlice({
  name: 'actions',
  initialState: {},
  reducers: {
    aLogin: ()=>{},
    aLogout: ()=>{},
    aGetInit: ()=>{},
    aGetInitTennis: ()=>{},
    aUserList: ()=>{},
    aUserAdd: ()=>{},
    aRoleInit: ()=>{},
    aGetPermissions: ()=>{},
    aSaveNewRole: ()=>{},
    aSaveEditRole: ()=>{},
    aUserResetPass: ()=>{},
    aUserRemove: ()=>{},
    aUserEditStatus: ()=>{},
    aUserEditRoles: ()=>{},
    aUserEditInfo: ()=>{},
    aRemoveRole: ()=>{},
    aDisableEnableRole: ()=>{},
    aGetProfileInfo: ()=>{},
    aChangeUserPwd: ()=>{},
    aGetEvents: ()=>{},
    aGetTennisEvents: ()=>{},
    aGetOddsDetails: ()=>{},
    aGetTennisOddsDetails: ()=>{},
    aExportToExcelRequest: ()=>{},
    aExportTennisToExcelRequest: ()=>{},
    aGetAutoBooking: ()=>{},
    aGetTennisAutoBooking: ()=>{},
    aGetMatchTimelineRequest: ()=>{},
    aGetTennisMatchTimelineRequest: ()=>{},
    aBookEvents: ()=>{},
    aUnbookEvents: ()=>{},
    aBookTennisEvents: ()=>{},
    aUnbookTennisEvents: ()=>{},
    aAddInterval: ()=>{},
    aAddTennisInterval: ()=>{},
    aSaveChanges: ()=>{},
    aSaveTennisChanges: ()=>{},
    aResetEventDetails: ()=>{},
    aResetTennisEventDetails: ()=>{},
    
    aGetFeedSettingsRequest: ()=>{},
    aUpdateFeedStatus: ()=>{},
    aUpdateOddsStatus: ()=>{},

    aGetTennisFeedSettingsRequest: ()=>{},
    aUpdateTennisFeedStatus: ()=>{},
    aUpdateTennisOddsStatus: ()=>{},

    aGetMarketSettingsRequest: ()=>{},
    aGetTennisMarketSettingsRequest: ()=>{},
    aUpdateOddsDisabledStatus: ()=>{},
    aUpdateTennisOddsDisabledStatus: ()=>{},
    aUpdateResultsDisabledStatus: ()=>{},
    aUpdateTennisResultsDisabledStatus: ()=>{},

    aGetCompetitorsRequest: ()=>{},
    aGetPlayersRequest: ()=>{},
    aSaveNewPlayerRequest: ()=>{},
    aDisablePlayerRequest: ()=>{},
    aUpdatePlayersOnSquad: ()=>{},
    aSaveUpdatedSquadListRequest: ()=>{},

    aGetMarketMarginsRequest: ()=>{},
    aUpdateMarketMarginsRequest: ()=>{},

    aGetTennisMarketMargins: ()=>{},
    aUpdateTennisMarketMarginsRequest: ()=>{},

    aGetLiveScoreStatusRequest: ()=>{},
    aUpdateLiveScoreStatusRequest: ()=>{},
    aGetEarlyPayoutSettingsRequest: ()=>{},

    aGetGoldenGoalSettingsRequest: ()=>{},
    aUpdateGoldenGoalSettingsRequest: ()=>{},

    aGetLiveTemplateFileRequest: ()=>{},
    aSaveLiveTemplateRequest: ()=>{},
    aSaveTennisLiveTemplateRequest: ()=>{},
    aGetLiveTemplateRequest: ()=>{},
    aGetTennisLiveTemplateRequest: ()=>{},
    aGetTennisLiveTemplateFileRequest: ()=>{},
    aSaveLiveTemplateFileRequest: ()=>{},
    aDownaloadLiveTemplateFileRequest: ()=>{},
    aSaveTennisLiveTemplateFileRequest: ()=>{},
    aDownloadTennisLiveTemplateFileRequest: ()=>{},

    aGetPlayersTemplateRequest: ()=>{},
    aSavePlayersTemplateRequest: ()=>{},
    aGetPlayersTemplateFileRequest: ()=>{},
    aUploadPlayersTemplateFileRequest: ()=>{},
    aDownloadPlayersTemplatesFile: ()=>{},
    aSavePlayersTemplatePreviewRequest: ()=>{},
    
    aGetPrematchMarketsByAccount: ()=>{},
    aSavePrematchMarketsByAccount: ()=>{},
    aSetPagination: ()=>{},
    aGetFeaturesFlagRequest: () => {},
    aUpdateFeaturesFlagRequest: () => {},
  }
});


export const {
  aSetPagination,
  aLogin,
  aLogout,
  aGetInit,
  aGetInitTennis,
  aUserList,
  aUserAdd,
  aRoleInit,
  aGetPermissions,
  aSaveNewRole,
  aSaveEditRole,
  aUserResetPass,
  aUserRemove,
  aUserEditStatus,
  aUserEditRoles,
  aUserEditInfo,
  aRemoveRole,
  aDisableEnableRole,
  aGetProfileInfo,
  aChangeUserPwd,
  aGetEvents,
  aGetTennisEvents,
  aGetOddsDetails,
  aGetTennisOddsDetails,
  aExportToExcelRequest,
  aExportTennisToExcelRequest,
  aGetAutoBooking,
  aGetTennisAutoBooking,
  aGetMatchTimelineRequest,
  aGetTennisMatchTimelineRequest,
  aBookEvents,
  aUnbookEvents,
  aBookTennisEvents,
  aUnbookTennisEvents,
  aAddInterval,
  aAddTennisInterval,
  aSaveChanges,
  aSaveTennisChanges,
  aResetEventDetails,
  aResetTennisEventDetails,
  aGetFeedSettingsRequest,
  aUpdateFeedStatus,
  aUpdateOddsStatus,
  aGetTennisFeedSettingsRequest,
  aUpdateTennisFeedStatus,
  aUpdateTennisOddsStatus,
  aGetMarketSettingsRequest,
  aGetTennisMarketSettingsRequest,
  aUpdateOddsDisabledStatus,
  aUpdateTennisOddsDisabledStatus,
  aUpdateResultsDisabledStatus,
  aUpdateTennisResultsDisabledStatus,
  aGetCompetitorsRequest,
  aGetPlayersRequest,
  aSaveNewPlayerRequest,
  aDisablePlayerRequest,
  aUpdatePlayersOnSquad,
  aSaveUpdatedSquadListRequest,
  aGetMarketMarginsRequest,
  aUpdateMarketMarginsRequest,
  aGetTennisMarketMargins,
  aUpdateTennisMarketMarginsRequest,
  aGetLiveScoreStatusRequest,
  aUpdateLiveScoreStatusRequest,
  aGetEarlyPayoutSettingsRequest,
  aGetGoldenGoalSettingsRequest,
  aUpdateGoldenGoalSettingsRequest,
  aGetLiveTemplateFileRequest,
  aSaveLiveTemplateRequest,
  aSaveTennisLiveTemplateRequest,
  aGetLiveTemplateRequest,
  aGetTennisLiveTemplateRequest,
  aGetTennisLiveTemplateFileRequest,
  aSaveLiveTemplateFileRequest,
  aDownaloadLiveTemplateFileRequest,
  aSaveTennisLiveTemplateFileRequest,
  aDownloadTennisLiveTemplateFileRequest,
  aGetPlayersTemplateRequest,
  aSavePlayersTemplateRequest,
  aGetPlayersTemplateFileRequest,
  aUploadPlayersTemplateFileRequest,
  aDownloadPlayersTemplatesFile,
  aSavePlayersTemplatePreviewRequest,
  aGetPrematchMarketsByAccount,
  aSavePrematchMarketsByAccount,
  aGetFeaturesFlagRequest,
  aUpdateFeaturesFlagRequest,
} = actionsSlice.actions;


